import { useState } from 'react';
import { IioTable } from '../../../components/IioTable';
import { useSearchTermLists, SearchTermList } from '../../../hooks/useSearchTerms';
import { FilterInput } from '../../../components/FilterInput';
import { LoadingPlaceholder } from '../../../components/LoadingPlaceholder';
import { formatLocaleDate } from '../../../utilities/date';
import { AddListModal } from './AddListModal';

interface Props {
  projectId: string;
  onOpen: (list: SearchTermList) => void;
}

export function ListsView({ projectId, onOpen }: Props) {
  const { data, isLoading } = useSearchTermLists(projectId);
  const [showModal, setShowModal] = useState(false);
  const [filterText, setFilterText] = useState('');

  const lists = (data?.searchTermLists ?? []).filter(l =>
    !filterText || l.name.toLowerCase().includes(filterText.toLowerCase())
  );

  return (
    <div>
      {showModal && (
        <AddListModal
          projectId={projectId}
          onClose={() => setShowModal(false)}
          onCreated={list => { setShowModal(false); onOpen(list); }}
        />
      )}

      <div className="row">
        <div className="col-md-8">
          <div className="btn-toolbar">
            <button className="btn btn-primary" onClick={() => setShowModal(true)}>
              New Search Terms <i className="fas fa-plus-circle" aria-hidden="true" />
            </button>
            <FilterInput value={filterText} onChange={setFilterText} />
          </div>
        </div>
      </div>

      <div className="row" style={{ marginTop: 12 }}>
        <div className="col-md-6">
          {isLoading && <LoadingPlaceholder />}
          {!isLoading && lists.length === 0 && (
            <p className="text-muted">No search term lists yet.</p>
          )}
          {lists.length > 0 && (
            <IioTable>
              <colgroup>
                <col />
                <col />
                <col style={{ width: 150 }} />
              </colgroup>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Date</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {lists.map(list => (
                  <tr key={list.id} className={list.status === 'Running' ? 'active' : ''}>
                    <td>
                      <a
                        href="#"
                        onClick={e => { e.preventDefault(); onOpen(list); }}
                        className={list.status === 'Running' ? 'text-muted' : ''}
                      >
                        {list.name}
                      </a>
                    </td>
                    <td>{formatLocaleDate(list.createdAt)}</td>
                    <td>{list.status}</td>
                  </tr>
                ))}
              </tbody>
            </IioTable>
          )}
        </div>
      </div>
    </div>
  );
}
